import { ButtonProps } from './types';
import { StyledButton } from './styles';

const Button = ({
  title,
  icon,
  format = 'contained',
  color = 'primary',
  ...props
}: ButtonProps) => (
  <StyledButton {...props} format={format} color={color} type="button">
    {icon}
    {title}
  </StyledButton>
);

export default Button;
